module.exports = __webpack_public_path__ + "media/images/icons/rss-924205d11392e487ed63952adf5468be.svg";